/**
 * SmartField numeric value formatter.
 *
 * Smart-field values arrive as strings, numbers, null/undefined or the empty
 * string. Numeric values are shown with two decimals when fractional and bare
 * when integral; non-numeric / missing values are passed through, falling back
 * to a dash when null/undefined.
 *
 * Bug it fixes: the previous `parseFloat(val).toFixed(2)` path turned a missing
 * value (null/undefined) into the literal string "NaN" on screen and in the
 * PDF, and stamped integer values with a spurious ".00". This guards both.
 */
export function formatSmartFieldNumber(val: any): any {
    if (val === 'NaN') {
        return '-';
    }
    const num = Number(val);
    if (val != null && val !== '' && !Number.isNaN(num)) {
        return Number.isInteger(num) ? num : num.toFixed(2);
    }
    return val ?? '-';
}
